import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import Modal from "../../Modal/CustomModal";
import { Modal as ModalReact } from 'react-bootstrap';
import Input from '../CustomInputs/Input';
import Phone from '../CustomInputs/Phone';
import PhoneInternational from '../CustomInputs/PhoneInternational';
import CNPJ from '../CustomInputs/CNPJ';
import CPF from '../CustomInputs/CPF';
import Select from "../CustomInputs/Select";
import SelectIcons from "../CustomInputs/SelectIcons";
import DateField from "../CustomInputs/DateField";
import TimeField from "../CustomInputs/TimeField";
import CustomCheckBox from "../CustomInputs/CustomCheckBox";
import Address from "../CustomInputs/Address";
import SortableTree from "../CustomInputs/SortableTree";
import SortableTreeTutorial from "../CustomInputs/SortableTreeTutorial";
import JsonInput from "../CustomInputs/JsonInput";
import FileUpload from "../CustomInputs/FileUpload";
import Integer from "../CustomInputs/Integer";
import WhatsAppQRCODE from "../CustomInputs/WhatsAppQRCODE";
import MultiInput from "../CustomInputs/MultiInput";
import Decimal from "../CustomInputs/Decimal";
import Year from "../CustomInputs/Year";
import Toast from '../../../Util/Toast/Toast';
import validate from 'validate.js';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import Fetch from '../../../../../util/core/Fetch';
import { useBasePath } from '../../../../../util/core/Path';
import { formatCurrency } from '../../../../../util/core/Currency';
import { diffDate } from '../../../../../util/core/DateHelper';
import { useSelector, useDispatch } from 'react-redux';
import './CustomForm.css';
import { allIcons } from "./fontAwesomeIcons";
import MultiSelect from "../CustomInputs/MultiSelect";
import QRCode from "react-qr-code";
import FileUploadS3 from "../CustomInputs/FileUploadS3";
import MultiFileUploadS3 from "../CustomInputs/MultiFileUploadS3";
import DateTimeField from "../CustomInputs/DateTimeField";
import MultiApiSearch from "../CustomInputs/MultiApiSearch";
import { SignatureField } from "../CustomInputs/SignatureField";
import RadioGroup from "../CustomInputs/RadioGroup";
import RG from "../CustomInputs/RG";
import MultiSelectCreatable from "../CustomInputs/MultiSelectCreatable";
import RichTextField from "../CustomInputs/RichTextField";
import { AddressAutoComplete } from "../CustomInputs/AddressAutoComplete";
import Routes from "../CustomInputs/Routes/Routes";
import DatePeriod from "../CustomInputs/DatePeriod"
import sleep from "sleep-promise";
import Divider from "../CustomInputs/Divider";
import MultiCheckBox from "../CustomInputs/MultiCheckBox";
import RecurrenceInput from "../CustomInputs/RecurrencyEvent";
import SearchInput from "../CustomInputs/SearchInput";
import CustomTooltipColumn from "./CustomTooltipColumn";
import CustomRangeSlider from "../CustomInputs/RangeSlider";
import RouteInput from '../CustomInputs/RouteInput';
import useSessionFilters from "../../List/hooks/useSessionFilters";
import PasswordChecklist from "react-password-checklist"
import SelectWithGroups from "../CustomInputs/SelectWithGroups";
import config from "../../../../../../application/config/config";

function CustomForm(props) {

    const dispatch = useDispatch();
    const session = useSelector((state) => { return state.session });
    const path = useBasePath();
    const inputRefs = useRef({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const customShowModal = useSelector((state) => { return state.session.custom_show_modal ? state.session.custom_show_modal : false });

    let { id } = useParams();
    id = props.form.id ? props.form.id : id;

    const iconsOptions = allIcons.map((icon) => {
        return { value: `nav-icon ${icon}`, label: icon }
    });

    const defaultHandleCloseModal = () => {
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_show_modal', value: false })
    }

    const navigate = useNavigate();
    let defaultPropsForm = {
        labelTitle: '',
        labelSubmitButton: 'Enviar',
        containerType: 'container',
        endpointSave: '',
        endpointTypeRequest: 'put',
        urlGoBack: '',
        handleSubmit: false,
        showGoBackButton: true,
        showSubmitButton: true,
        dropdownButton: [],
        showContainerButtons: true,
        validateOnChange: false,
        modalOptions: {
            title: 'Modal',
            size: 'md',
            content: <div> Modal Teste</div>,
            showButtons: true,
            handleConfirm: () => { },
            handleShow: () => { },
            handleClose: defaultHandleCloseModal,
            handleCancel: defaultHandleCloseModal
        },
        hiddenValues: {},
        buttonsFooter: [],
        afterSubmit: (form, values, loadData) => {
            if (props.form.containerType == 'dialog') {
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
            } else {
                if (props.form.urlGoBack && props.form.urlGoBack != '') {
                    navigate(props.form.urlGoBack);
                }
            }
        },
        afterReset: () => {

        },
        form: [],
        customValidators: {}
    }

    if (path == props.form.pathView) {
        defaultPropsForm.showSubmitButton = false;
        defaultPropsForm.readOnly = true;
    }
    let [form, setForm] = useState({ ...defaultPropsForm, ...props.form });
    let [fields, updateFields] = useState([]);
    let inputs = {};
    let [values, updateValues] = useState({});
    let [errors, updateErrors] = useState({});
    let [passwordIsValid, setPasswordIsValid] = useState({});
    const [loginConfigs, setLoginConfigs] = useState();
    const [firstErrorRef, setFirstErrorRef] = useState(null);
    let [reset, setReset] = useState(false);

    const passwordCheckerProps = useMemo(() => {
        if (loginConfigs?.password_validation === "1") {
            switch (loginConfigs?.password_validation_type) {
                case "easy":
                    return {
                        rules: ["minLength"],
                        minLength: 8,
                    };

                case "hard":
                    return {
                        rules: ["minLength", "specialChar", "number", "letter"],
                        minLength: 8,
                    };

                default:
                    return {
                        rules: ["minLength", "number", "letter"],
                        minLength: 8,
                    };
            }
        } else {
            return {
                rules: [],
            };
        }
    }, [loginConfigs]);

    useEffect(() => {
        const loadForm = async () => {
            dispatch({ type: 'SHOW_LOADING', value: true });
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_show_modal', value: false })
            let formValues = props.form.values;
            let formFields = props.form.fields;

            if (
                props.form.endpointGetById
                && id
                && !formValues
            ) {
                let postData = { id: id };
                let response = await Fetch.post(props.form.endpointGetById, postData);
                formValues = response;
            }

            let inputs = prepareValuesToLoad(formFields, formValues);


            updateValues(inputs);
            updateFields(formFields);

            let loginConfigs = await Fetch.post(config.endpoints.backend + "core/loginconfigs/getloginconfigs");
            setLoginConfigs(loginConfigs);

            dispatch({ type: 'SHOW_LOADING', value: false });
            dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: formValues ? formValues : {} });
            dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: formValues ? formValues : {} });
        }
        loadForm();
        return () => {
            dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: {} });
            dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: {} });
        };
    }, []);

    useEffect(() => {
        if (props.form.endpointGetById && id && !props.form.values) return;

        setForm(prev => ({ ...prev, ...props.form }));
        updateFields(props.form.fields);
    }, [props.form]);

    const { clearFilters } = useSessionFilters();

    useEffect(() => {
        if (reset) {
            const loadForm = async () => {
                dispatch({ type: 'SHOW_LOADING', value: true });
                let formValues = {};
                let formFields = props.form.fields;
                updateValues(formValues);
                updateFields([]);
                await sleep(10)
                updateFields(formFields);
                clearFilters();
                dispatch({ type: 'SHOW_LOADING', value: false });
                dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: formValues ? formValues : {} });
                dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: formValues ? formValues : {} });
            }
            loadForm();
            if (form.afterReset) {
                form.afterReset();
            }
        }
    }, [reset]);

    const goBack = () => {
        if (form.customGoBackHandler) {
            form.customGoBackHandler()
        } else if (form.containerType == 'dialog') {
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
        } else if (form.urlGoBack && form.urlGoBack != '') {
            navigate(form.urlGoBack);
        } else {
            navigate(-1);
        }
    }

    const handleChange = (element, field) => {
        let tempValues = values;

        tempValues[element.target.name] = element.target.value;

        updateValues(prev => ({ ...prev, ...tempValues }));

        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });
        if (field && field.handleChange) {


            const values = prepareValuesToSubmit();
            field.handleChange(element, field, values);
        }
        if (form.validateOnChange) {
            validateForm(element.target.name);
        }
    };

    const handleRecurrenceChange = (element, item) => {
        let tempValues = values;

        const frequencyData = {
            repeatUnit: element.repeatUnit,
            repeatInterval: element.repeatInterval,
            repeatMonthDay: element.repeatMonthDay,
            repeatDays: element.repeatDays ? Array.from(element.repeatDays) : []
        };

        tempValues.frequency = frequencyData;

        updateValues(tempValues);
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });

        if (item && item.handleChange) {
            const values = prepareValuesToSubmit();
            item.handleChange(element, item, values);
        }

        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleSearchChange = (element, item) => {
        let tempValues = values;

        const selectedSearchs = {
            id: element.id,
            name: element.name,
            photo: element.photo,
        };

        if (!tempValues[form.searchField]) {
            tempValues[form.searchField] = [selectedSearchs];
        } else {
            tempValues[form.searchField] = [...tempValues[form.searchField], selectedSearchs];
        }

        updateValues(tempValues);
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });

        if (item && item.handleChange) {
            const values = prepareValuesToSubmit();

            item.handleChange(element, item, values);
        }

        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleSearchChangeRemove = (itemId) => {
        let tempValues = values;
        tempValues[form.searchField] = tempValues[form.searchField].filter(i => i.id !== itemId);

        updateValues(tempValues);
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });

        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleChangeDatePeriod = (element, field) => {
        let tempValues = values;
        tempValues[element.target.name] = {
            start: {
                name_start: element.target.name_start,
                value_start: element.target.value_start
            },
            end: {
                name_end: element.target.name_end,
                value_end: element.target.value_end
            }
        };
        updateValues(tempValues);
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });
        if (field && field.handleChange) {
            const values = prepareValuesToSubmit();
            field.handleChange(element, field, values);
        }
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const onUpload = (inputName, file) => {
        dispatch({ type: 'SHOW_LOADING', value: false });
        let tempValues = values;
        tempValues[inputName] = file;
        updateValues(tempValues);
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const beforeUpload = element => {
        dispatch({ type: 'SHOW_LOADING', value: true });
    };

    const deleteUpload = (inputName, element) => {
        let tempValues = values;
        tempValues[inputName] = '';
        updateValues(tempValues);
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const updateMultiApiSearch = (inputName, value) => {
        let tempValues = values;
        tempValues[inputName] = value;
        updateValues(tempValues);
        if (value.length > 0) {
            if (form.validateOnChange) {
                validateForm();
            }
        }
    }

    const deleteUploadMulti = (inputName, elementToRemove) => {
        const updatedFiles = values[inputName].filter((file) => file.files3 !== elementToRemove.files3);
        const tempValues = { ...values, [inputName]: updatedFiles };
        updateValues(tempValues);

        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleCheckBox = (element, field) => {
        let tempValues = values;
        tempValues[element.target.name] = element.target.checked ? '1' : '';
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });
        if (field && field.handleChange) {
            const values = prepareValuesToSubmit();
            field.handleChange(element, field, values);
        }
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleSubmit = async (element) => {
        setIsSubmitting(true);
        dispatch({ type: 'SHOW_LOADING', value: true });
        element.preventDefault();
        const { isValid, firstErrorFieldRef } = await validateForm();

        const preparedValues = prepareValuesToSubmit();

        dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: preparedValues ? preparedValues : {} });

        if (!isValid) {
            Toast.error(`O formulário possui erros. Favor verificar.`);
        } else {
            if (typeof form.handleSubmit === 'function') {
                await form.handleSubmit(form.fields, preparedValues, form.loadData);
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
                if (form.afterSubmit) {
                    form.afterSubmit(form, preparedValues, form.loadData);
                }
            } else if (form.endpointSave != '') {
                const response = await submitForm(preparedValues);
                
                if (response.status == 1) {
                    Toast.success('Informações atualizadas com sucesso!');
                } else {
                    Toast.error('Erro ao atualizar informações!');
                }

                if (form.afterSubmit) {
                    form.afterSubmit(form, preparedValues, response);
                }
            }
        }

        dispatch({ type: 'SHOW_LOADING', value: false });
        setIsSubmitting(false);
    }

    const submitForm = async (values) => {
        let response = '';
        if (form.endpointTypeRequest == 'put') {
            response = await Fetch.put(form.endpointSave, values);
        } else {
            response = await Fetch.post(form.endpointSave, values);
        }
        return response;
    }

    const prepareValuesToLoad = (formFields, formValues) => {
        let option = {};

        for (let [key, value] of Object.entries(formFields)) {
            let tempValue = '';
            if (formValues) {
                tempValue = formValues[value.name] !== undefined && formValues[value.name] !== null ? formValues[value.name] : '';
            }
            switch (value.type) {
                case "checkbox":
                    inputs[value.name] = tempValue ? "1" : "";
                    break;
                case "address":
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case "select":
                    option = value.options.filter((selected) => selected.value == tempValue);
                    inputs[value.name] = option.value ? option : { label: "", value: tempValue };
                    break;
                case "selectIcons":
                    option = iconsOptions.filter((selected) => selected.value == tempValue);
                    inputs[value.name] = option.value ? option : { label: "", value: tempValue };
                    break;
                case 'multiselect':
                    let multiSelectOptions = [];
                    let selectedValues = [];
                    if (formValues && formValues[value.name]) {
                        selectedValues = formValues[value.name];
                        multiSelectOptions = value.options.filter(option => (
                            selectedValues.some(selectedValue => selectedValue === option.value)
                        ));
                    }
                    inputs[value.name] = multiSelectOptions && multiSelectOptions.length > 0 ? multiSelectOptions : selectedValues;
                    break;
                case "password":
                    inputs[value.name] = "";
                    break;
                case "sourcetree":
                    inputs[value.name] = tempValue ? tempValue : [{}];
                    break;
                case "decimal":
                    inputs[value.name] = formatCurrency(tempValue);
                    break;
                case "integer":
                    if (formValues) {
                        if (formValues[value.name] !== undefined && formValues[value.name] !== null) {
                            inputs[value.name] = tempValue;
                        }
                    }
                    break;

                case "multiApiSearch":
                    inputs[value.name] = tempValue ? tempValue : [];
                    break;
                case "radioGroup":
                    option = value.options.filter((opt) => opt.selected);
                    if (tempValue === "") {
                        inputs[value.name] = option[0].value ? option[0].value : "";
                    } else {
                        inputs[value.name] = tempValue
                    }
                    break;
                case "date_period":
                    inputs[value.name] = {
                        start: {
                            name_start: value.name_start,
                            value_start: formValues ? formValues[value.name_start] : null
                        },
                        end: {
                            name_end: value.name_end,
                            value_end: formValues ? formValues[value.name_end] : null
                        }
                    };
                    inputs[value.name_start] = formValues ? formValues[value.name_start] : null
                    inputs[value.name_end] = formValues ? formValues[value.name_end] : null
                    break;
                case 'multicheckbox':
                    let selectedCheckBoxValues = tempValue ? tempValue : [];
                    inputs[value.name] = selectedCheckBoxValues;
                    break;
                default:
                    inputs[value.name] = tempValue ? tempValue : "";
                    break;
            }
        }
        return inputs;
    }

    const prepareValuesToSubmit = () => {
        let inputs = [];
        for (let [key, value] of Object.entries(form.fields)) {
            let tempValue = '';
            if (values) {
                tempValue = values[value.name] ? values[value.name] : '';
            }

            switch (value.type) {
                case 'checkbox':
                    inputs[value.name] = tempValue ? '1' : '';
                    break;
                case 'address':
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case 'select':
                    if (typeof tempValue === "object") {
                        inputs[value.name] = tempValue.value ? tempValue.value : '';
                    } else {
                        inputs[value.name] = tempValue ? tempValue : '';
                    }
                    break;
                case 'selectIcons':
                    if (typeof tempValue === "object") {
                        inputs[value.name] = tempValue.value ? tempValue.value : '';
                    } else {
                        inputs[value.name] = tempValue ? tempValue : '';
                    }
                    break;
                case 'sortabletree':
                    inputs[value.name] = session['core-sorteable-data-' + value.name]
                    break;
                case 'decimal':
                    const temp = tempValue.replace(/\./g, '').replace(',', '.');
                    inputs[value.name] = temp ? temp : null;
                    break;
                case 'integer':
                    inputs[value.name] = (values[value.name] === 0 || values[value.name]) ? values[value.name] : '';
                    break;
                case 'datetime':
                    inputs[value.name] = tempValue ? tempValue : null;
                    break;
                case 'date':
                    inputs[value.name] = tempValue ? tempValue : null;
                    break;
                case 'recurrency':
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case 'searchInput':
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case 'multiApiSearch':
                    inputs[value.name] = tempValue ? tempValue : [];
                    break;
                case 'date_period':

                    const start = tempValue.start || {}
                    const end = tempValue.end || {}

                    inputs[value.name] = tempValue ? tempValue : [];
                    inputs[value.name_start] = start.value_start ? start.value_start : null
                    inputs[value.name_end] = end.value_end ? end.value_end : null
                    break;
                case 'multicheckbox':
                    inputs[value.name] = tempValue || [];
                    break;
                case 'rangeSlider':
                    const [initialValue, finalValue] = tempValue?.length > 1 ? tempValue : [];

                    inputs[value.name] = {
                        min: initialValue,
                        max: finalValue,
                        measure: value?.measure
                    }

                    break;
                default:
                    inputs[value.name] = tempValue ? tempValue : '';
                    break;
            }
        }
        inputs = { ...inputs, ...form.hiddenValues };

        if (id) {
            inputs.id = id;
        }
        return inputs;

    }

    const getSchemaValidations = () => {
        let validations = {};
        for (let [key, field] of Object.entries(form.fields)) {
            let value = { ...field };
            if (value.validations) {
                validations[value.name] = value.validations;
                if (value.validations.required) {
                    value.validations.presence = {
                        message: `^O campo ${value.label} é obrigatório`,
                        allowEmpty: false
                    }
                }

                switch (value.type) {
                    case 'phone':
                        if (values[value.name].length > 1) {
                            value.validations.length = {
                                minimum: 10,
                                tooShort: ' inválido'
                            }
                        } else {
                            value.validations.length = false;
                        }
                        break;
                    case 'address':
                        value.validations.address = true;
                        break;
                    case 'password':
                        value.validations.password = true;
                        break;
                    case 'email':
                        value.validations.email = values[value.name] !== '' || false
                        break;
                    case 'CNPJ':
                        value.validations.cnpj = true;
                        break;
                    case 'CPF':
                        value.validations.cpf = true;
                        break;
                    case 'multiinput':
                        value.validations.multiinput = value.validations.required || false;
                        break;
                    case 'date_period':
                        value.validations.date_period = value.validations.required || false;
                        break;
                    case 'recurrency':
                        value.validations.recurrency = true;
                        break;
                    case 'multicheckbox':
                        if (value.type === 'multicheckbox') {
                            if (value.validations.required) {
                                value.validations.multicheckbox = true;
                                value.validations.presence = {
                                    message: `^O campo ${value.label} é obrigatório`,
                                    allowEmpty: false
                                };
                            } else {
                                value.validations.presence = false;
                            }
                        }
                        break;
                }
            }
            validations[value.name] = value.validations;
        }
        return validations;
    }

    const validateForm = useCallback(async (field) => {
        setIsSubmitting(true)

        let schemaValidations = getSchemaValidations();

        if (field) {
            let fields = Object.keys(errors ? errors : {}).filter(key => {
                return errors[key] != ''
            });
            fields.push(field);
            fields = [...new Set(fields)];
            let tempSchemaValidations = {};
            for (const item of fields) {
                tempSchemaValidations[item] = schemaValidations[item];
            }
            schemaValidations = tempSchemaValidations;
        }

        validate.validators.required = function (value, options, key, attributes) {
            return "";
        }

        validate.validators.recurrency = function (value, options, key, attributes) {
            if (!value.repeatInterval || !value.repeatUnit) {
                return '^ Por favor, configure a recorrência.';
            }

            if (value.repeatInterval <= 0) {
                return '^ O intervalo de repetição deve ser maior que zero.';
            }

            return '';
        };

        validate.validators.address = function (value, options, key, attributes) {
            for (let [key2, value2] of Object.entries(value)) {
                if (key2 != 'complement' && value2 == '') {
                    return 'Preencha todos os campos obrigatórios de endereço.';
                }
            }
            return "";
        }

        validate.validators.multicheckbox = function (value, options, key, attributes) {
            const checked = value.filter(item => (item.value === true));
            if (checked.length == 0) {
                return '^ Selecione ao menos um item da listagem.';
            }
            return "";
        }

        validate.validators.cpf = function (value, options, key, attributes) {
            if (value != '' && !cpf.isValid(value)) {
                return '^CPF inválido';
            } else {
                return "";
            }
        }

        validate.validators.cnpj = function (value, options, key, attributes) {
            if (value != '' && !cnpj.isValid(value)) {
                return '^CNPJ inválido';
            } else {
                return "";
            }
        }

        validate.validators.multiinput = function (value, options, key, attributes) {
            const { form: formMultiInput } = form.fields.find((item) => item.name === key);

            const hasRepeatedValues = formMultiInput.some(item => !!item.repeatedValue);
            if (hasRepeatedValues) return '^ ';

            const requiredFields = formMultiInput.filter((item) => {
                if (item?.validations?.required) {
                    return item;
                }
            });

            const formattedRequiredFields = requiredFields.map((validation) => validation.name);

            function validateItem(finalValue) {

                if (Array.isArray(finalValue)) {
                    return finalValue.length === 0;
                }
                if (typeof finalValue === "object") {
                    return validate.isEmpty(finalValue.value);
                }
                return validate.isEmpty(finalValue);
            }

            for (let value2 of Object.values(value)) {
                const finalValidation = formattedRequiredFields.map((key2) => validateItem(value2[key2]))
                if (finalValidation.some((validation => validation === true))) {
                    return '^ ';
                }
            }

            return "";
        }
        validate.validators.date_period = function (value, options, key, attributes) {
            if (!value.start.value_start) {
                return '^ Preencha a data de início';
            }

            if (!value.end.value_end) {
                return '^ Preencha a data de término';
            }

            if (diffDate(value.start.value_start, value.end.value_end) < 0) {
                return '^ Data de início deve ser menor ou igual a data de término';
            }
        }

        validate.validators.password = function (value, options, key, attributes) {
            if (passwordIsValid[key] === false) {
                return '^A senha está inválida';
            } else {
                return '';
            }
        }

        validate.validators = { ...validate.validators, ...props.form.customValidators };

        let validations = undefined;
        try {
            const preparedValues = prepareValuesToSubmit();
            await validate.async(preparedValues, schemaValidations);
        } catch (error) {
            validations = error;
        }
        let validation = {};
        let firstErrorFieldRef = null;

        for (let [key, field] of Object.entries(form.fields)) {
            const errorMessage = validations?.[field.name]?.[0] || "";
            validation[field.name] = errorMessage;

            if (!firstErrorFieldRef && errorMessage) {
                firstErrorFieldRef = inputRefs.current[field.name];
            }
        }
        updateErrors(validation);
        setFirstErrorRef(firstErrorFieldRef);
        return { isValid: !validations, firstErrorFieldRef };
    }, [errors, form.fields, getSchemaValidations, passwordIsValid, prepareValuesToSubmit, props.form.customValidators]);

    useEffect(() => {
        if (isSubmitting && firstErrorRef) {
            firstErrorRef.scrollIntoView({ behavior: "smooth", block: "center" });
            setIsSubmitting(false);
        }
    }, [isSubmitting, firstErrorRef]);


    return (
        <>
            <Modal
                show={customShowModal}
                size={form.modalOptions.size}
                handleClose={!!form.modalOptions.handleClose ? form.modalOptions.handleClose : defaultHandleCloseModal}
                handleCancel={!!form.modalOptions.handleCancel ? form.modalOptions.handleCancel : defaultHandleCloseModal}
                title={form.modalOptions.title}
                content={form.modalOptions.content}
                showButtons={form.modalOptions.showButtons}
            />
            <form id="crudform" >
                <div className="card-body">
                    <div className="row">
                        {fields && fields.map((item, index) => {
                            let className = "form-group col-sm-12";
                            if (item.columnSize) {
                                className = 'form-group col-sm-' + item.columnSize;
                            }
                            switch (item.type) {
                                case 'label':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} ref={(el) => (inputRefs.current[item.name] = el)}>{item.label}</label>
                                            <div>{item.value}</div>
                                        </div>
                                    )
                                    break;
                                case 'divider':
                                    return (
                                        <Divider />
                                    )
                                    break;
                                case 'routes':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Routes
                                                name={item.name}
                                                value={values[item.name]}
                                                id={item.id}
                                                inputType={item.inputType}
                                                onChange={handleChange}
                                                onAdd={handleChange}
                                                onDelete={handleChange}
                                                styleTh={item.styleTh}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                selectParams={item.selectParams}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'text':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type="text"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                className={errors[item.name] ? 'input-error' : ''}
                                                maxLength={item.maxLength ? item.maxLength : 80}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                mask={item.mask}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'email':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type="text"
                                                name={item.name}
                                                value={values[item.name]}
                                                maxLength={item.maxLength ? item.maxLength : 50}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'phone':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Phone
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'phone-international':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <PhoneInternational
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'password':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type="password"
                                                name={item.name}
                                                value={values[item.name]}
                                                maxLength={item.maxLength ? item.maxLength : 100}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                            {item.name !== "password_confirm" && (
                                                <>
                                                    <PasswordChecklist
                                                        {...passwordCheckerProps}
                                                        style={{ marginTop: "1rem" }}
                                                        value={values[item.name] || ''}
                                                        valueAgain={values[item.name]}
                                                        onChange={(isValid) => setPasswordIsValid(prev => ({
                                                            ...prev,
                                                            [item.name]: isValid,
                                                        }))}
                                                        messages={{
                                                            minLength: `A senha deve conter no mínimo ${passwordCheckerProps.minLength} caracteres.`,
                                                            specialChar: "A senha deve conter caracteres especiais.",
                                                            number: "A senha deve conter números.",
                                                            letter: "A senha deve conter letras.",
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    )
                                    break;
                                case 'textarea':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type='textarea'
                                                name={item.name}
                                                value={values[item.name]}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                maxLength={item.maxLength ? item.maxLength : 4000}
                                                rows={item.rows || "5"}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'CNPJ':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <CNPJ
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'CPF':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <CPF
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'select':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Select
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                options={item.options}
                                                optionsEndpoint={props.form.fields[index]?.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                isClearable={item.isClearable === false ? false : true}
                                                canAutoFill={item.canAutoFill ? item.canAutoFill : false}
                                                required={item.validations.required ? item.validations.required : false}
                                                sort={item.sort}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'selectwithgroups':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <SelectWithGroups
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                options={item.options}
                                                optionsEndpoint={props.form.fields[index]?.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                isClearable={item.isClearable === false ? false : true}
                                                canAutoFill={item.canAutoFill ? item.canAutoFill : false}
                                                required={item.validations.required ? item.validations.required : false}
                                                sort={item.sort}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'multiselect':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <MultiSelect
                                                name={item.name}
                                                value={values[item.name]}
                                                creatable={item.creatable}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                options={item.options}
                                                optionsEndpoint={item.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                acceptOneOption={item.acceptOneOption ? item.acceptOneOption : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'multiselectCreatable':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <MultiSelectCreatable
                                                name={item.name}
                                                value={values[item.name]}
                                                creatable={item.creatable}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                options={item.options}
                                                optionsEndpoint={item.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'selectIcons':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <SelectIcons
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                options={iconsOptions}
                                                optionsEndpoint={item.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'date':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <DateField
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                options={item.options}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                item={item}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'time':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <TimeField
                                                name={item.name}
                                                value={values[item.name]}
                                                defaultValue={item.defaultValue}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                options={item.options}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'datetime':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <DateTimeField
                                                name={item.name}
                                                defaultValue={item.defaultValue}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                options={item.options}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'checkbox':
                                    return (
                                        <div className={className} style={!item.switch ? { marginLeft: '20px' } : {}} key={item.name} >
                                            <CustomCheckBox
                                                name={item.name}
                                                onChange={(element) => { handleCheckBox(element, item) }}
                                                checked={values[item.name]}
                                                error={errors[item.name]}
                                                label={item.label}
                                                required={item.validations.required}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                switch={item.switch ? item.switch : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'multicheckbox':
                                    return (
                                        <div className={className} style={!item.switch ? { marginLeft: '20px' } : {}} key={item.name} >
                                            <label htmlFor={'id_' + item.name} style={{ marginLeft: '-20px' }}>
                                                {item.label}
                                            </label>
                                            <MultiCheckBox
                                                name={item.name}
                                                onChange={(element) => {
                                                    handleChange(element, item)
                                                }}
                                                value={values[item.name]}
                                                creatable={item.creatable}
                                                error={errors[item.name]}
                                                options={item.options}
                                                showSelectAll={item.showSelectAll}
                                                optionsEndpoint={item.optionsEndpoint}
                                                switch={item.switch ? item.switch : false}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                acceptOneOption={item.acceptOneOption ? item.acceptOneOption : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'address':
                                    return (
                                        <div className={className} key={item.name} >
                                            {item.autocomplete ? (
                                                <AddressAutoComplete
                                                    type="text"
                                                    name={item.name}
                                                    value={values[item.name]}
                                                    onChange={handleChange}
                                                    error={errors[item.name]}
                                                    maxLength={item.maxLength ? item.maxLength : 80}
                                                    readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                    autoFocus={item.autoFocus}
                                                    ref={(el) => (inputRefs.current[item.name] = el)}
                                                    hasComplement={item.hasComplement}
                                                />) : (
                                                <Address
                                                    name={item.name}
                                                    onChange={handleChange}
                                                    error={errors[item.name]}
                                                    googleMap={item.googleMap}
                                                    label={item.label}
                                                    value={values[item.name]}
                                                    required={item.validations.required}
                                                    invalid={false}
                                                    readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                    ref={(el) => (inputRefs.current[item.name] = el)}
                                                />
                                            )}
                                        </div>
                                    )
                                    break;
                                case 'sortabletree':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            <SortableTree
                                                name={item.name}
                                                onChange={handleChange}
                                                onChangeTreeData={item.onChangeTreeData}
                                                value={values[item.name]}
                                                fields={item.fieldsForm}
                                                labelNewItem={item.labelNewItem}
                                                labelTitleModal={item.labelTitleModal}
                                                wrapTitle={item.wrapTitle}
                                                customValidators={item.customValidators}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'sortabletreetutorial':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <SortableTreeTutorial
                                                name={item.name}
                                                onChange={handleChange}
                                                onChangeTreeData={item.onChangeTreeData}
                                                value={values[item.name]}
                                                fields={item.fieldsForm}
                                                childFieldsForm={item.childFieldsForm}
                                                labelNewItem={item.labelNewItem}
                                                labelTitleModal={item.labelTitleModal}
                                                wrapTitle={item.wrapTitle}
                                                customValidators={item.customValidators}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                customStyles={item.customStyles}
                                                levelsLimit={item.levelsLimit}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'json':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <JsonInput
                                                name={item.name}
                                                onChange={handleChange}
                                                value={values[item.name]}
                                                width={item.width ? item.width : '100%'}
                                                height={item.height ? item.height : '300px'}
                                                fields={item.fieldsForm}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'file':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <FileUpload
                                                name={item.name}
                                                path={item.uploadPath}
                                                file={values[item.name]}
                                                onUpload={onUpload}
                                                onRemove={deleteUpload}
                                                beforeUpload={beforeUpload}
                                                accept={item.extensionAccept}
                                                titleButton={item.titleButton}
                                                limitFileSize={item.limitFileSize}
                                                error={errors[item.name]}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'fileS3':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.description && typeof item.description === 'function' && item.description()}
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <FileUploadS3
                                                name={item.name}
                                                crop={item.crop}
                                                path={item.uploadPath}
                                                file={values[item.name]}
                                                onUpload={onUpload}
                                                onRemove={deleteUpload}
                                                beforeUpload={beforeUpload}
                                                accept={item.extensionAccept}
                                                titleButton={item.titleButton}
                                                limitFileSize={item.limitFileSize}
                                                error={errors[item.name]}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                maxDuration={item.maxDuration ? item.maxDuration : 60}
                                                confirmRemove={item.confirmRemove ? item.confirmRemove : false}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'multiUploadFileS3':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <MultiFileUploadS3
                                                name={item.name}
                                                path={item.uploadPath}
                                                file={values[item.name]}
                                                onUpload={onUpload}
                                                onRemove={deleteUploadMulti}
                                                beforeUpload={beforeUpload}
                                                accept={item.extensionAccept}
                                                titleButton={item.titleButton}
                                                limitFileSize={item.limitFileSize}
                                                uploadFileLimit={item.uploadFileLimit}
                                                error={errors[item.name]}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'whatsappqrcode':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <WhatsAppQRCODE
                                                name={item.name}
                                                value={values[item.name]}
                                                id={item.id}
                                                endpoint={item.endpoint}
                                                endpointqrcode={item.endpointqrcode}
                                                endpointlogout={item.endpointlogout}
                                                phone_name={item.phone_name}
                                                token={item.token}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'qrcode':
                                    return (
                                        <div className={className} key={item.name}>
                                            <div className="d-flex flex-column">
                                                <label>{item.label}</label>
                                                <div className="d-flex flex-column align-items-start" style={{ gap: 6 }}>
                                                    <QRCode
                                                        value={item.value}
                                                        size={item.size ? item.size : 100}
                                                    />
                                                    {item.showValue && <span style={{ opacity: .7 }}>{item.value}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    break;
                                case 'multiinput':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <MultiInput
                                                name={item.name}
                                                id={item.id}
                                                value={values[item.name]}
                                                sortBy={item.sortBy ? item.sortBy : ''}
                                                form={item.form}
                                                showDeleteButton={item.showDeleteButton ? item.showDeleteButton : false}
                                                unique={item.unique}
                                                limit={item.limit}
                                                paths={props.form}
                                                endpoint={item.endpoint}
                                                onChange={(element) => handleChange(element, item)}
                                                onAdd={(element) => handleChange(element, item)}
                                                onDelete={(element) => handleChange(element, item)}
                                                styleTh={item.styleTh}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'integer':
                                    return (
                                        <div className={className} key={item.name}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label htmlFor={'id_' + item.name} >
                                                    {item.label}
                                                </label>
                                                {item.validations.required && (
                                                    <span className="required"> *</span>
                                                )}
                                                {item.tooltip && (
                                                    <div style={{ display: 'flex', alignItems: 'center', padding: '0 3px', marginBottom: '10px' }}>
                                                        <CustomTooltipColumn tooltip={item.tooltip} />
                                                    </div>
                                                )}
                                            </div>
                                            <Integer
                                                type="number"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                placeholder={item.placeholder}
                                                maxLength={item.maxLength}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    );
                                    break;
                                case 'decimal':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Decimal
                                                type="text"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                maxLength={item.maxLength ? item.maxLength : 100}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'submit':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label>
                                                &nbsp;
                                            </label>
                                            <div>
                                                <button onClick={handleSubmit} type="button" className="btn btn-primary">
                                                    {item.label}
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    break;
                                case 'reset':
                                    return (
                                        <div className={className} key={item.name} style={{ marginLeft: '10px' }}>
                                            <label>
                                                &nbsp;
                                            </label>
                                            <div>
                                                <button onClick={async () => {
                                                    setReset(new Date());
                                                }} type="button" className="btn btn-secondary">
                                                    {item.label}
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    break;
                                case 'color':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type="color"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'month':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Input
                                                type="month"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'multiApiSearch':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <MultiApiSearch
                                                onChange={updateMultiApiSearch}
                                                name={item.name}
                                                value={values[item.name]}
                                                endpoint_method={item.endpoint_method}
                                                endpoint_filter={item.endpoint_filter}
                                                endpoint={item.endpoint}
                                                response_type={item.response_type}
                                                label_column={item.label_column}
                                                label_path={item.label_path}
                                                value_path={item.value_path}
                                                required_input_search={item.required_input_search}
                                                titleButton={item.titleButton}
                                                error={errors[item.name]}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                unique={item.unique || null}
                                                items_limit={item.items_limit || false}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'year':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <Year
                                                type="number"
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                                selectable={item.selectable || false}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'signature':
                                    return (
                                        <div className="d-flex flex-column" key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <SignatureField
                                                name={item.name}
                                                value={values[item.name]}
                                                error={errors[item.name]}
                                                onUpload={onUpload}
                                                onRemove={deleteUpload}
                                                beforeUpload={beforeUpload}
                                                uploadPath={item.uploadPath}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'radioGroup':
                                    return (
                                        <div className={className} key={item.name}  >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <RadioGroup
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }} error={errors[item.name]}
                                                options={item.options}
                                                optionsEndpoint={item.optionsEndpoint}
                                                disabled={(item.readOnly || form.readOnly) ? true : false}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'RG':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <RG
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={handleChange}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'richText':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <RichTextField
                                                name={item.name}
                                                value={values[item.name]}
                                                onChange={(element) => { handleChange(element, item) }}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'date_period':
                                    return (
                                        <div className={className} key={item.name} >
                                            <DatePeriod
                                                name={item.name}
                                                name_start={item.name_start}
                                                name_end={item.name_end}
                                                value={values[item.name_start]}
                                                valueEnd={values[item.name_end]}
                                                label={item.label}
                                                required={item.validations.required}
                                                onChange={(element) => { handleChangeDatePeriod(element, item) }}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'recurrency':
                                    return (
                                        <div className={className} key={item.name}>
                                            <RecurrenceInput
                                                name={item.name}
                                                label={item.label}
                                                required={item.validations.required}
                                                value={values[item.name]}
                                                onChange={(element) => handleRecurrenceChange(element, item)}
                                                error={errors[item.name]}
                                                readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                autoFocus={item.autoFocus}
                                                ref={(el) => (inputRefs.current[item.name] = el)}
                                            />
                                        </div>
                                    );
                                    break;
                                case 'searchInput':
                                    return (
                                        <>
                                            <div className={className} key={item.name} style={{ float: 'right', textAlign: 'right' }}>
                                                <SearchInput
                                                    name={item.name}
                                                    label={item.label}
                                                    options={item.options}
                                                    required={item.validations.required}
                                                    value={values[item.name]}
                                                    addButtonLabel={item.addButtonLabel}
                                                    endpoint={item.endpoint}
                                                    searchParams={item.searchParams}
                                                    onChange={(element) => handleSearchChange(element, item)}
                                                    onRemove={handleSearchChangeRemove}
                                                    error={errors[item.name]}
                                                    readOnly={(item.readOnly || form.readOnly) ? true : false}
                                                    autoFocus={item.autoFocus}
                                                    ref={(el) => (inputRefs.current[item.name] = el)}
                                                />
                                            </div>
                                        </>
                                    );
                                    break;
                                case 'route':
                                    return (
                                        <div className={className} key={item.name}>
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <RouteInput
                                                name={item.name}
                                                pointA={values[item.name]?.pointA}
                                                pointB={values[item.name]?.pointB}
                                            />
                                        </div>
                                    )
                                    break;
                                case 'customInput':
                                    const customParams = {
                                        item,
                                        values,
                                        handleChange,
                                        errors,
                                        inputRefs,
                                        form
                                    }
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations?.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <div style={{ display: 'block' }}>
                                                {item.component(customParams)}
                                            </div>
                                        </div>
                                    )
                                    break;
                                case 'rangeSlider':
                                    return (
                                        <div className={className} key={item.name} >
                                            <label htmlFor={'id_' + item.name} >
                                                {item.label}
                                            </label>
                                            {item.validations.required && (
                                                <span className="required"> *</span>
                                            )}
                                            <CustomRangeSlider
                                                name={item.name}
                                                min={item.min}
                                                max={item.max}
                                                measure={item.measure}
                                                onChange={(element) => handleChange(element, item)}
                                                value={values[item.name]}
                                            />
                                        </div>
                                    )
                                    break;
                            }
                        })}
                    </div>
                </div>
                {/* /.card-body */}
                {form.showContainerButtons && (
                    (form.containerType == 'container') ? (
                        <div className="card-footer d-flex justify-content-end">
                            {form.showGoBackButton && (
                                <button onClick={goBack} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                    Voltar
                                </button>
                            )}
                            {form.buttonsFooter.map((button) => {
                                return (
                                    <button onClick={() => { button.onClick(form) }} type="button" className={button.className ? button.className : 'btn btn-primary'} style={button.style ? button.style : { marginRight: '10px' }} disabled={!!button.disabled}>
                                        {button.label}
                                    </button>
                                )
                            })}
                            {form.dropdownButton && (
                                form.dropdownButton
                            )}
                            {form.showSubmitButton && (<button onClick={handleSubmit} type="button" className="btn btn-primary">{form.labelSubmitButton}</button>)}
                        </div>
                    ) : (
                        <ModalReact.Footer>
                            {form.showGoBackButton && (
                                <button onClick={goBack} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                    Voltar
                                </button>
                            )}
                            {form.buttonsFooter.map((button) => {
                                return (
                                    <button onClick={() => { button.onClick(form) }} type="button" className={button.className ? button.className : 'btn btn-primary'} style={button.style ? button.style : { marginRight: '10px' }} disabled={!!button.disabled}>
                                        {button.label}
                                    </button>
                                )
                            })}
                            {form.showSubmitButton && (<button onClick={handleSubmit} type="button" className="btn btn-primary">{form.labelSubmitButton}</button>)}
                        </ModalReact.Footer>
                    )
                )}
            </form>
        </>
    );
}

export default CustomForm;